/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  exercise: {
    name: 'Übung',
    rest: 'Ruhen Sie sich einen Moment aus.',
    pause: 'Sie sind in der Pause.',
    pauseMessage:
      'Nehmen Sie sich Zeit, und wenn Sie bereit sind, drücken Sie den untenstehenden Button.',
    complete: 'Übung abgeschlossen.',
    end: 'Herzlichen Glückwunsch! Sie sind am Ende Ihrer Trainingseinheit angekommen. Machen Sie weiter mit Ihrer guten Arbeit: Durchhaltevermögen ist eine wesentliche Voraussetzung für Ihren Erfolg.',
    empty:
      'Es wurde noch kein Interventionsplan für Sie erstellt. Bitte wenden Sie sich an Ihren Kliniker, um Ihr Übungsprofil zu aktivieren.',
  },
};
